import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { X } from "lucide-react"

import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center gap-1 font-medium text-xs transition-colors",
  {
    variants: {
      variant: {
        default:
          "bg-white border border-black rounded-lg px-2.5 py-1.5 text-[#344054]",
        selected:
          "bg-primary border border-primary rounded-lg px-2.5 py-1.5 text-white",
        outline:
          "bg-transparent border border-gray-300 rounded-lg px-2.5 py-1.5 text-gray-600",
        pink:
          "bg-[#FDF2F8] border border-[#ED5AA9] rounded-lg px-2.5 py-1.5 text-[#ED5AA9]",
        blue:
          "bg-white border border-[#0D41E1] rounded-lg px-2.5 py-1.5 text-[#0D41E1]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  label: string
  removable?: boolean
  onRemove?: () => void
}

function Badge({
  className,
  variant,
  label,
  removable = false,
  onRemove,
  ...props
}: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props}>
      <span>{label}</span>
      {removable && (
        <button
          type="button"
          onClick={onRemove}
          className="ml-0.5 hover:opacity-70 transition-opacity"
          aria-label={`Remove ${label}`}
        >
          <X className="size-3" />
        </button>
      )}
    </div>
  )
}

export { Badge, badgeVariants }
